import React from "react";
import CommonDateInput from "../../../../components/CommonDateInput";

/**
 * Renders a single tab of OMS order fields (ASN GenericFormTab–style layout, without ASN-specific logic).
 */
export default function OrderFormTab({
  fields,
  formData,
  onChange,
  viewOnly = false,
  formSubmissionAttempted = false,
}) {
  const handleInput = (e) => {
    const { name, value, type } = e.target;
    const v = type === "number" && value !== "" ? Number(value) : value;
    onChange({ target: { name, value: v } });
  };

  const visibleFields = fields.filter((f) => {
    if (!f.conditional) return true;
    return formData[f.conditional.field] === f.conditional.value;
  });

  return (
    <div className="row gx-2 mx-2">
      {visibleFields.map((field) => {
        const isRequired =
          field.required && !field.readOnly && !field.readonly && !viewOnly;
        const fieldValue = formData[field.name];
        const isEmpty =
          fieldValue === null ||
          fieldValue === undefined ||
          fieldValue === "" ||
          (typeof fieldValue === "string" && fieldValue.trim() === "");
        const hasError = formSubmissionAttempted && isRequired && isEmpty;
        const disabled = viewOnly || field.readOnly || field.readonly;

        const colClass =
          field.type === "textarea" ? "col-md-4" : "col-md-2";

        return (
          <div className={colClass} key={field.name}>
            <div className="form-group mb-2">
              <label htmlFor={field.name} className="form-label">
                {field.label}
                {isRequired && <span className="text-danger">*</span>}
              </label>
              {field.hint && (
                <div className="form-text small text-muted mb-1">{field.hint}</div>
              )}

              {field.type === "select" ? (
                <select
                  id={field.name}
                  className={`form-select ${hasError ? "is-invalid" : ""}`}
                  name={field.name}
                  value={formData[field.name] ?? ""}
                  onChange={handleInput}
                  disabled={disabled}
                >
                  <option value="">Select</option>
                  {field.options?.map((opt) =>
                    typeof opt === "object" ? (
                      <option key={opt.value} value={opt.value}>
                        {opt.label}
                      </option>
                    ) : (
                      <option key={opt} value={opt}>
                        {opt}
                      </option>
                    )
                  )}
                </select>
              ) : field.type === "textarea" ? (
                <textarea
                  id={field.name}
                  className={`form-control ${hasError ? "is-invalid" : ""}`}
                  name={field.name}
                  value={formData[field.name] ?? ""}
                  onChange={handleInput}
                  readOnly={disabled}
                  rows={3}
                />
              ) : field.type === "date" ? (
                <CommonDateInput
                  id={field.name}
                  name={field.name}
                  value={formData[field.name]}
                  onChange={onChange}
                  readOnly={disabled}
                  required={field.required}
                  className={hasError ? "is-invalid" : ""}
                  showTime={false}
                />
              ) : (
                <input
                  id={field.name}
                  type={
                    field.type === "number"
                      ? "number"
                      : field.type === "email"
                        ? "email"
                        : "text"
                  }
                  className={`form-control ${hasError ? "is-invalid" : ""}`}
                  name={field.name}
                  value={
                    field.type === "number" && formData[field.name] === 0
                      ? 0
                      : formData[field.name] ?? ""
                  }
                  onChange={handleInput}
                  readOnly={disabled}
                  step={field.step}
                />
              )}

              {hasError && (
                <div className="invalid-feedback">{field.label} is required</div>
              )}
            </div>
          </div>
        );
      })}
    </div>
  );
}
